import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Common/Header";
import Footer from "../components/Common/Footer";
import Connect from "../components/Common/connect";

const Root = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Connect />
      <Footer />
    </>
  );
};

export default Root;
